import { BlockData } from 'types';

interface UseMenuBlocksParams {
  blocks: BlockData[];
  keyword: string;
  nodeType: string;
}

const useMenuBlocks = ({ blocks, keyword, nodeType }: UseMenuBlocksParams) => {
  const filteredBlocks = blocks.filter((block) => block.name.toLowerCase().includes(keyword));

  const handleBlockDragStart = (event: React.DragEvent, dragData: any) => {
    event.dataTransfer.setData(nodeType, JSON.stringify(dragData));
    event.dataTransfer.effectAllowed = 'move';
  };

  return {
    filteredBlocks,
    onBlockDragStart: handleBlockDragStart,
  };
};

export default useMenuBlocks;
